<mat-dialog-content>
    <div class="text-center">{{ 'text.processing' | translate }}...</div>
</mat-dialog-content>
